export function hasExtractableEmbedded3d(attachments) {
    return !!attachments?.some(item => item.is_3d);
}
export function buildPendingEmbeddedExtraction(lineItemId, drawingFileId, attachments, partLabel) {
    if (!attachments.length || !hasExtractableEmbedded3d(attachments)) {
        return null;
    }
    return {
        lineItemId,
        drawingFileId,
        attachments,
        partLabel,
    };
}
export function enqueueEmbeddedExtraction(queue, item) {
    if (queue.some(entry => entry.lineItemId === item.lineItemId)) {
        return queue;
    }
    return [...queue, item];
}
export function dequeueEmbeddedExtraction(queue) {
    if (!queue.length) {
        return queue;
    }
    return queue.slice(1);
}
